<template>
  <FocusTrap
    v-if="value"
    class="fixed inset-0 w-full h-full"
    style="background-color: #171717; z-index: 1000;"
    role="dialog"
    aria-modal="true"
  >
    <div style="background-color: #333; height: 45px;">
      <slot name="header" />
    </div>

    <div
      class="overflow-y-auto"
      style="height: calc(100vh - 45px);"
    >
      <slot />
    </div>
  </FocusTrap>
</template>

<script>
import FocusTrap from 'vue-aria-focus-trap';

export default {
  components: {
    FocusTrap,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    value(newVal) {
      this.$nextTick(() => {
        if (newVal) {
          document.body.style.overflow = 'hidden';
          document.addEventListener('keyup', this.handleEscape);
        } else {
          document.body.style.overflow = null;
          document.removeEventListener('keyup', this.handleEscape);
        }
      });
    },
  },

  beforeDestroy() {
    document.removeEventListener('keyup', this.handleEscape);
  },

  methods: {
    handleEscape(evt) {
      if (evt.key === 'Escape') {
        this.$emit('input', false);
      }
    },
  },
};
</script>
